import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
} from "@chakra-ui/react";
import { useQuery } from "react-query";
import axios from "axios";
import { useTranslation } from "react-i18next";

export function OutstandingBonoAlert() {
  const { t } = useTranslation();

  const {
    data: hasPendingBono,
    isLoading,
    isError,
  } = useQuery(
    ["outstandingBono"],
    async () => {
      const { data } = await axios.get("/api/bonos/outstanding/payment");
      return data;
    },
    {
      staleTime: 60 * 1000, // 1 minuto
      refetchOnWindowFocus: false,
    },
  );

  // Si está cargando o hay error, no mostramos nada
  if (isLoading || isError || !hasPendingBono) return null;

  return (
    <Box>
      <Alert status="error" justifyContent="center">
        <AlertIcon />
        <AlertTitle>{t("outstandingBono.title")}</AlertTitle>
        <AlertDescription fontWeight="400">
          {t("outstandingBono.description")}
        </AlertDescription>
      </Alert>
    </Box>
  );
}
